import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDashboardDialog } from '@actions/dashboard-actions';
import { copyToClipboard } from '@actions/data-detail-actions';
import * as dialog from '@constants/dialogs';
import Dialog from '@shared/dialogs/dialog';
import DialogActions from '@shared/dialogs/dialog-actions';
import DialogSnackbar from '@shared/dialogs/dialog-snackbar';
import { useEntityTypeScheduleEnabled } from '@components/config/hooks';
import { buildEntitySchedule } from '@utils/segment-schedule/copy-to-clipboard';
import './view-schedule-dialog.scss';

const ViewScheduleDialog = () => {
  const dispatch = useDispatch();
  const { activeDialogs, dialogParams: allDialogParams = {} } = useSelector(state => state.dashboard);
  const dialogParams = allDialogParams[dialog.VIEW_SCHEDULE] || {};
  const { dataType, data = {} } = dialogParams;
  const scheduleEnabled = useEntityTypeScheduleEnabled(dataType);
  const schedule = useMemo(() => {
    if (scheduleEnabled) {
      return buildEntitySchedule(data);
    }
    return null;
  }, [scheduleEnabled, data]);

  const isDialogActive = activeDialogs[dialog.VIEW_SCHEDULE];

  const onCopy = useCallback(
    () => {
      dispatch(copyToClipboard('view-schedule-textarea', 'view-schedule-display-text'));
    },
    [dispatch]
  );

  const onClose = useCallback(
    () => {
      dispatch(closeDashboardDialog(dialog.VIEW_SCHEDULE));
    },
    [dispatch]
  );

  if (!isDialogActive || !dialogParams || !schedule) {
    return null;
  }

  return (
    <Dialog
      actions={
        <DialogActions
          onCancel={onClose}
          onSubmit={onCopy}
          submitLabel="COPY TO CLIPBOARD"
        />
      }
      title="View Schedule"
    >
      <div styleName="view-schedule-dialog-text-legend">
        Copy and paste the {dialogParams.dataType} schedule to clipboard.
      </div>
      <div
        id="view-schedule-display-text"
        styleName="view-schedule-dialog-text-container"
      >
        {schedule}
      </div>
      {/* hidden textarea (for copying to clipboard) */ }
      <textarea
        id="view-schedule-textarea"
        styleName="view-schedule-dialog-hidden-textarea"
        readOnly
        value={schedule}
      />
      <DialogSnackbar />
    </Dialog>
  );
};

export default memo(ViewScheduleDialog);
